var map = {
	".": [
		6292
	],
	"./": [
		6292
	],
	"./accordion": [
		2621,
		697
	],
	"./accordion.scss": [
		3051,
		817
	],
	"./accordion.ts": [
		2621,
		697
	],
	"./index": [
		6292
	],
	"./index.ts": [
		6292
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 9690;
module.exports = webpackAsyncContext;